// source: mlmbox/type/exchanger.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var mlmbox_type_asset_pair_pb = require('../../mlmbox/type/asset_pair_pb.js');
goog.object.extend(proto, mlmbox_type_asset_pair_pb);
goog.exportSymbol('proto.mlmbox.type.Exchanger', null, global);
goog.exportSymbol('proto.mlmbox.type.Exchanger.Rate', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Exchanger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.Exchanger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Exchanger.displayName = 'proto.mlmbox.type.Exchanger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Exchanger.Rate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.Exchanger.Rate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Exchanger.Rate.displayName = 'proto.mlmbox.type.Exchanger.Rate';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Exchanger.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Exchanger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Exchanger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Exchanger.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Exchanger}
 */
proto.mlmbox.type.Exchanger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Exchanger;
  return proto.mlmbox.type.Exchanger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Exchanger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Exchanger}
 */
proto.mlmbox.type.Exchanger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Exchanger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Exchanger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Exchanger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Exchanger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Exchanger.Rate.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Exchanger.Rate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Exchanger.Rate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Exchanger.Rate.toObject = function(includeInstance, msg) {
  var f, obj = {
    assetPair: (f = msg.getAssetPair()) && mlmbox_type_asset_pair_pb.AssetPair.toObject(includeInstance, f),
    rateBuy: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rateSell: jspb.Message.getFieldWithDefault(msg, 3, ""),
    modifiedAt: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Exchanger.Rate}
 */
proto.mlmbox.type.Exchanger.Rate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Exchanger.Rate;
  return proto.mlmbox.type.Exchanger.Rate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Exchanger.Rate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Exchanger.Rate}
 */
proto.mlmbox.type.Exchanger.Rate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new mlmbox_type_asset_pair_pb.AssetPair;
      reader.readMessage(value,mlmbox_type_asset_pair_pb.AssetPair.deserializeBinaryFromReader);
      msg.setAssetPair(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRateBuy(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRateSell(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setModifiedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Exchanger.Rate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Exchanger.Rate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Exchanger.Rate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Exchanger.Rate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetPair();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      mlmbox_type_asset_pair_pb.AssetPair.serializeBinaryToWriter
    );
  }
  f = message.getRateBuy();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRateSell();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModifiedAt();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional AssetPair asset_pair = 1;
 * @return {?proto.mlmbox.type.AssetPair}
 */
proto.mlmbox.type.Exchanger.Rate.prototype.getAssetPair = function() {
  return /** @type{?proto.mlmbox.type.AssetPair} */ (
    jspb.Message.getWrapperField(this, mlmbox_type_asset_pair_pb.AssetPair, 1));
};


/**
 * @param {?proto.mlmbox.type.AssetPair|undefined} value
 * @return {!proto.mlmbox.type.Exchanger.Rate} returns this
*/
proto.mlmbox.type.Exchanger.Rate.prototype.setAssetPair = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mlmbox.type.Exchanger.Rate} returns this
 */
proto.mlmbox.type.Exchanger.Rate.prototype.clearAssetPair = function() {
  return this.setAssetPair(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.type.Exchanger.Rate.prototype.hasAssetPair = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string rate_buy = 2;
 * @return {string}
 */
proto.mlmbox.type.Exchanger.Rate.prototype.getRateBuy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Exchanger.Rate} returns this
 */
proto.mlmbox.type.Exchanger.Rate.prototype.setRateBuy = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string rate_sell = 3;
 * @return {string}
 */
proto.mlmbox.type.Exchanger.Rate.prototype.getRateSell = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Exchanger.Rate} returns this
 */
proto.mlmbox.type.Exchanger.Rate.prototype.setRateSell = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 modified_at = 4;
 * @return {number}
 */
proto.mlmbox.type.Exchanger.Rate.prototype.getModifiedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.Exchanger.Rate} returns this
 */
proto.mlmbox.type.Exchanger.Rate.prototype.setModifiedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.mlmbox.type);
